// ── BB SOCIAL HUB JS ──
document.addEventListener('DOMContentLoaded', function () {
  const copyBtn = document.querySelector('.bbsoc-copy-btn');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      const tags = copyBtn.dataset.hashtags || '';
      if (!tags) return;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(tags).then(function () {
          const original = copyBtn.textContent;
          copyBtn.textContent = '✓ Copied to Clipboard!';
          setTimeout(function () { copyBtn.textContent = original; }, 3000);
        });
      }
    });
  }
});
